// extracted by css-extract-rspack-plugin
export default {"root":"ImzdDJ","label":"f0Wudf","separator":"YPInM6","form":"RU6wr2","core-icon":"Ou_Xpp","coreIcon":"Ou_Xpp"};